export const MOCK_IDS = {
  EDITION: 'edition-active-1',
  COMPETITION_HIKE: 'competition-hike',
  COMPETITION_RUN: 'competition-run',
  DISTANCE_SHORT: 'distance-short',
  DISTANCE_LONG: 'distance-long',
  ACCOMMODATION_TENT: 'accommodation-tent',
  ROLE_SUPER: 'role-0',
  ROLE_ADMIN: 'role-1',
  ROLE_USER: 'role-10',
  USER_SUPER: 'user-super',
  USER_ADMIN: 'user-admin',
  USER_REGULAR: 'user-regular',
  PAGE_SIGNUP: 'page-signup',
  PAGE_HOME: 'page-home',
  PAGE_CONTENT_HOME: 'content-home',
  SPONSOR_1: 'sponsor-1',
  TRACK_MAP_1: 'trackmap-1',
  FILE_1: 'file-1',
} as const;

export const MOCK_AUTH = {
  ACCESS_TOKEN: 'mock-access-token',
  REFRESH_TOKEN: 'mock-refresh-token',
  ADMIN_EMAIL: 'mock-admin@local',
  REGULAR_EMAIL: 'mock-user@local',
  PASSWORD: 'MockPass1!',
} as const;
